import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-equipment-grps',
  templateUrl: './equipment-grps.component.html',
  styleUrls: ['./equipment-grps.component.css']
})
export class EquipmentGrpsComponent implements OnInit {
    public itemsListEquipmentGroups: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadEquipmentGroups() {
        this.itemsListEquipmentGroups = await this.datatask.Post(2047);
    }

    private async init() {
        this.loadEquipmentGroups();
    }

    ngOnInit() {
        this.init();
    }
}
